import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { MsalProvider } from '@azure/msal-react'
import { PostHogProvider } from 'posthog-js/react'
import { msalInstance } from './config/authConfig'
import { ProductsProvider } from './context/ProductsContext'
import { IngredientsProvider } from './context/IngredientsContext'
import { ServicesProvider } from './context/ServicesContext'
import { initPostHog, posthog } from './analytics/posthog'
import { initSentry } from './analytics/sentry'
import './index.css'
import App from './App.jsx'

initSentry()
initPostHog()

const envTitleSuffix = {
  staging: ' - Staging',
  preview: ' - Preview',
}[import.meta.env.VITE_ENV] || ''
document.title = `Activ OS${envTitleSuffix}`

// Swap in an environment-specific favicon so non-production tabs/bookmarks are
// visually distinct (staging = amber, preview = teal).
const envFavicon = {
  staging: '/favicon-staging.svg',
  preview: '/favicon-preview.svg',
}[import.meta.env.VITE_ENV]
if (envFavicon) {
  const link = document.querySelector('link[rel="icon"]') || document.createElement('link')
  link.rel = 'icon'
  link.type = 'image/svg+xml'
  link.href = envFavicon
  if (!link.isConnected) document.head.appendChild(link)
}

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <PostHogProvider client={posthog}>
      <MsalProvider instance={msalInstance}>
        <BrowserRouter>
          <ProductsProvider>
            <IngredientsProvider>
              <ServicesProvider>
                <App />
              </ServicesProvider>
            </IngredientsProvider>
          </ProductsProvider>
        </BrowserRouter>
      </MsalProvider>
    </PostHogProvider>
  </StrictMode>,
)
